export default "__VITE_ASSET__D$DYy$Ts__"